module.exports = __webpack_public_path__ + "img/sponsor_gallery_grid8.f78cfb94.png";